import { useTranslation } from 'react-i18next';
import { color as token } from '@figma/fpl-tokens/tokens.stylex';
import { AppIconButton } from '@/UI/Buttons/AppIconButton';
import { ArrowIcon } from '@/UI/Icons';
import { I18N_KEYS } from '@/language/keys';

interface ArrowProps {
  right: boolean;
  onClick: () => void;
}
export const Arrow = ({ right, onClick }: ArrowProps) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        width: 32,
        height: 32,
        backgroundColor: token.bg,
        position: 'absolute',
        left: right ? 'auto' : '5px',
        right: right ? '5px' : 'auto',
        top: '50%',
        transform: 'translateY(-50%)',
      }}
    >
      <AppIconButton
        aria-label={t(right ? I18N_KEYS.GENERAL.ARIA.SCROLL_RIGHT : I18N_KEYS.GENERAL.ARIA.SCROLL_LEFT)}
        onClick={onClick}
        width={32}
        height={32}
      >
        <ArrowIcon
          width={16}
          height={16}
          style={{ transform: right ? 'rotate(90deg)' : 'rotate(-90deg)', color: token.text }}
        />
      </AppIconButton>
    </div>
  );
};
